import AgentManages from '@/pages/agentManage/agentManages'

export default [
  {
    path: '/agentManages',
    name: 'AgentManages',
    component: AgentManages,
    meta: { name: '代理商管理' }
  }
]



// WEBPACK FOOTER //
// ./src/router/agentManage/agentManages.js